import moment from 'moment';
import { Box } from '@mui/material';
import NumberSlot from '../../components/number-slot/NumberSlot';
import { ReactComponent as EditIcon } from '../../assets/images/edit.svg';
import { ReactComponent as CloseIcon } from '../../assets/images/close-circle.svg';
import { UserInterface } from '../../utils/types/user';
import IconButton from '@mui/material/IconButton';
import { MRT_ColumnDef } from 'material-react-table';
import { VesselInterface } from '../../utils/types/vessel';
import StatusSlot from '../../components/number-slot/StatusSlot';
import { getDisabledRowTextStyle, TABLE_TEXT_ACCENT } from '../../utils/tableRowStyles';

const formatRoleLabel = (role?: string) => {
  if (!role) return '';
  return role.charAt(0).toUpperCase() + role.slice(1);
};

const listAdminsGridColumns = (
  onEditUser: (user: UserInterface) => void,
  onDeleteUser: (user: UserInterface) => void
): Array<MRT_ColumnDef<UserInterface>> => [
  {
    accessorKey: 'createdAt',
    header: 'Date',
    Cell: ({ cell }) => {
      const date = new Date(cell.getValue<string>());
      const humanReadableDate = moment(date).fromNow();

      return (
        <span style={{ color: TABLE_TEXT_ACCENT, fontWeight: 500 }}>{humanReadableDate}</span>
      );
    }
  },
  {
    accessorKey: 'name',
    header: 'Name',
    Cell: ({ cell, row }) => (
      <span style={getDisabledRowTextStyle(row.original.status)}>{cell.getValue<string>()}</span>
    )
  },
  {
    accessorKey: 'email',
    header: 'Email',
    Cell: ({ cell, row }) => (
      <span style={getDisabledRowTextStyle(row.original.status)}>{cell.getValue<string>()}</span>
    )
  },
  {
    accessorKey: 'phone',
    header: 'Phone',
    Cell: ({ cell, row }) => (
      <span style={getDisabledRowTextStyle(row.original.status)}>{cell.getValue<string>()}</span>
    )
  },
  {
    accessorKey: 'assignedVessels',
    header: 'Yacht assigned',
    enableSorting: false,
    Cell: ({ cell }) => {
      const vessels = cell.getValue<VesselInterface[]>()?.length ?? 0;
      const count = vessels.toString().padStart(2, '0');

      return <NumberSlot value={count} />;
    }
  },
  {
    id: 'role',
    header: 'Role',
    enableSorting: false,
    Cell: ({ row }) => {
      const user = row.original;
      const roleLabel = formatRoleLabel(user.role);

      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            width: '100%',
            minWidth: 160
          }}>
          {roleLabel ? (
            <StatusSlot
              value={roleLabel}
              backgroundSlot="#D4D9E6"
              backgroundValue="#273F82"
              fontSize="small"
            />
          ) : (
            <span />
          )}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton color="secondary" aria-label="Edit" onClick={() => onEditUser(user)}>
              <EditIcon />
            </IconButton>
            <IconButton color="secondary" aria-label="Delete" onClick={() => onDeleteUser(user)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      );
    }
  }
];

export default listAdminsGridColumns;
